import { SectionsAreaCascadeRendererBase } from "./sections-area-cascade-renderer-base";
import { IMainSectionsAreaData } from "src/typings/section-area-data";
import { RendererFactory } from "src/shared/renderer-factory";
import { MainSectionsAreaRenderer } from "../renderers/main-sections-area-renderer";
import { IRenderingCommonContext } from "@commonRendering/types";

export class MainSectionsAreaCascadeRenderer extends SectionsAreaCascadeRendererBase<IMainSectionsAreaData> {

    public constructor(renderingCommonContext: IRenderingCommonContext) {
        super(RendererFactory.create("MainSectionsArea", renderingCommonContext) as MainSectionsAreaRenderer, renderingCommonContext);
    }

}
